<h2 mat-dialog-title>{{ 'DELETE_INSTALLATION_DIALOG_TITLE' | i18nextCap }}</h2>
<mat-dialog-content>
  <p>
    {{
      'DELETE_INSTALLATION_DIALOG_TEXT'
        | i18nextCap
          : { companyName: data.companyName, equipmentName: data.equipmentName }
    }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" type="button" [mat-dialog-close]="false">
    {{ 'cancel' | i18nextCap }}
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [mat-dialog-close]="true"
  >
    {{ 'continue' | i18nextCap }}
  </button>
</mat-dialog-actions>
